export default "__VITE_ASSET__3a63b4c0__"